export default {
  methods: {
    getEnumTranslatedValue(enumName, enumValue) {
      const mapping = {
        address_customer_usage: {
          main: "Principale",
          corresponding: "Correspondance",
          accounting: "Comptabilité",
          social: "Documents sociaux",
        },
        civility: {
          mr: "M.", 
          mrs: "Mme", 
          company: "Société",
        },
        customer_status: {
          'active-blocked': "Actif-Bloqué",
          'active-unpaid': "Actif-Impayé",
          'active-litigation': "Actif-Contentieux",
          'active-judicial-liquidation': "Actif-Liquid jud",
          'active-terminating': "Actif-En cours résil",
          'active-redirection': "Actif-Réexpédition",
          'active-vip': "Actif-VIP  Fipromer",
          'active-renting': "Actif-Location",
          'active-secretariat': "Actif-Secrétariat",
          'active-sleep': "Actif-Sommeil",
          'active': "Actif",
          'classified-transfer': "Classé-Transfert",
          'classified-radiation': "Classé-Radiation",
          'classified-judicial-liquidation': "Classé-Liquid judici",
          'classified-non-payment': "Classé-Non-paiement",
          'classified-other': "Classé-Autre",
          'classified-dissolution': "Classé-Dissolution",
          'classified-tc-radiation': "Classé-Radiation TC",
          'classified-insee-radiation': "Classé-Rad INSEE",
          'classified-prefecture-radiation': "Classé-Rad Préf",
          'classified-contract-cancel': "Classé-Annul contrat",
          'classified-not-registered': "Classé-Pas inscrit",
          'classified-sdm-termination': "Classé-Résili SDM",
          'classified-sofradom-termination': "Classé-Résili SOFRA",
          'classified-abc-termination': "Classé-Résili ABC",
          'classified-address-stop': "Classé-Arrêt adresse",
          'closed': "Clos",
        },
        customer_vigilance_status: {
          simple: "Simple",
          complementary: "Complémentaire",
          reinforced: "Renforcée",
        },
        customer_person_type: {
          representative: "Représentant légal",
          contact: "Contact",
        },
        legal_form: {
          eirl: "E.I.R.L",
          eurl: "E.U.R.L",
          sarl: "S.A.R.L",
          sa: "S.A",
          sas: "S.A.S",
          sasu: "S.A.S.U",
          sci: "S.C.I",
          snc: "S.N.C",
          liberal_profession: "Profession libérale",
          foreign_rights_institution: "Etablissement en France de droit étranger",
          artisan: "Artisan",
          association: "Association",
          auto_entrepreneur: "Auto-entrepreneur",
          ei: "Entreprise individuelle",
          rc: "RC",
          non_profit_organization: "Association à but humanitaire",
          individual: "Particulier",
          other: "Autre",
        },
        legal_form_group: {
          rcs_company: "Société inscrite au registre du commerce", 
          non_rcs_company: "Société non inscrite au registre du commerce", 
          foreign_company: "Société en France de droit étranger",
          association: "Association",
          non_profit_organization: "Association à but humanitaire",
        },
        representative_quality: {
          manager: "Gérant",
          president: "Président",
          ceo: "Directeur général",
          co_manager: "Co-gérant",
          vice_president: "Vice-président",
          steering_committee: "Comité directeur",
          sales_director: "Directeur des achats",
          purchasing_manager: "Directeur des ventes",
          personnel_manager: "Chef du personnel",
          quality_manager: "Responsable qualité",
          production_manager: "Directeur de la production",
          executive_secretary: "Secrétaire de direction",
          it_manager: "Directeur informatique",
          chief_financial_officer: "Directeur financier",
          chief_marketing_officer: "Directeur marketing",
          president_ceo: "Président Directeur Général",
          director: "Directeur",
          accountant: "Comptable",
          associate: "Associé",
          lawyer: "Avocat",
          secretary: "Secrétaire",
          treasurer: "Trésorier",
          representative: "Représentant légal",
        },
        validation_request_status: {
          pending: "En attente de validation",
          validated: "Validée",
          refused: "Refusée",
        }
      }

      return mapping[enumName][enumValue] || null
    },

    getUsStateTranslatedValue(code) {
      const mapping = {
        AL: "Alabama",
        AK: "Alaska",
        AS: "American Samoa",
        AZ: "Arizona",
        AR: "Arkansas",
        CA: "California",
        CO: "Colorado",
        CT: "Connecticut",
        DE: "Delaware",
        DC: "District of Columbia",
        FM: "Federated States of Micronesia",
        FL: "Florida",
        GA: "Georgia",
        GU: "Guam",
        HI: "Hawaii",
        ID: "Idaho",
        IL: "Illinois",
        IN: "Indiana",
        IA: "Iowa",
        KS: "Kansas",
        KY: "Kentucky",
        LA: "Louisiana",
        ME: "Maine",
        MH: "Marshall Islands",
        MD: "Maryland",
        MA: "Massachusetts",
        MI: "Michigan",
        MN: "Minnesota",
        MS: "Mississippi",
        MO: "Missouri",
        MT: "Montana",
        NE: "Nebraska",
        NV: "Nevada",
        NH: "New Hampshire",
        NJ: "New Jersey",
        NM: "New Mexico",
        NY: "New York",
        NC: "North Carolina",
        ND: "North Dakota",
        MP: "Northern Mariana Islands",
        OH: "Ohio",
        OK: "Oklahoma",
        OR: "Oregon",
        PW: "Palau",
        PA: "Pennsylvania",
        PR: "Puerto Rico",
        RI: "Rhode Island",
        SC: "South Carolina",
        SD: "South Dakota",
        TN: "Tennessee",
        TX: "Texas",
        UT: "Utah",
        VT: "Vermont",
        VI: "Virgin Islands",
        VA: "Virginia",
        WA: "Washington",
        WV: "West Virginia",
        WI: "Wisconsin",
        WY: "Wyoming",
        AE: "Armed Forces Europe, the Middle East, and Canada",
        AP: "Armed Forces Pacific",
        AA: "Armed Forces Americas (except Canada)",
      }

      return mapping[code] || null
    },

    getCountryTranslatedValue(code) {
      const mapping = {
        AF: "Afghanistan",
        ZA: "Afrique du Sud",
        AL: "Albanie",
        DZ: "Algérie",
        DE: "Allemagne",
        AD: "Andorre",
        AO: "Angola",
        AI: "Anguilla",
        AQ: "Antarctique",
        AG: "Antigua-et-Barbuda",
        SA: "Arabie saoudite",
        AR: "Argentine",
        AM: "Arménie",
        AW: "Aruba",
        AU: "Australie",
        AT: "Autriche",
        AZ: "Azerbaïdjan",
        BS: "Bahamas",
        BH: "Bahreïn",
        BD: "Bangladesh",
        BB: "Barbade",
        BE: "Belgique",
        BZ: "Belize",
        BJ: "Bénin",
        BM: "Bermudes",
        BT: "Bhoutan",
        BY: "Biélorussie",
        BO: "Bolivie",
        BA: "Bosnie-Herzégovine",
        BW: "Botswana",
        BR: "Brésil",
        BN: "Brunéi Darussalam",
        BG: "Bulgarie",
        BF: "Burkina Faso",
        BI: "Burundi",
        KH: "Cambodge",
        CM: "Cameroun",
        CA: "Canada",
        CV: "Cap-Vert",
        CL: "Chili",
        CN: "Chine",
        CY: "Chypre",
        CO: "Colombie",
        KM: "Comores",
        CG: "Congo-Brazzaville",
        CD: "Congo-Kinshasa",
        KP: "Corée du Nord",
        KR: "Corée du Sud",
        CR: "Costa Rica",
        CI: "Côte d’Ivoire",
        HR: "Croatie",
        CU: "Cuba",
        CW: "Curaçao",
        DK: "Danemark",
        DJ: "Djibouti",
        DM: "Dominique",
        EG: "Égypte",
        AE: "Émirats arabes unis",
        EC: "Équateur",
        ER: "Érythrée",
        ES: "Espagne",
        EE: "Estonie",
        SZ: "Eswatini",
        VA: "État de la Cité du Vatican",
        FM: "États fédérés de Micronésie",
        US: "États-Unis",
        ET: "Éthiopie",
        FJ: "Fidji",
        FI: "Finlande",
        FR: "France",
        GA: "Gabon",
        GM: "Gambie",
        GE: "Géorgie",
        GS: "Géorgie du Sud et îles Sandwich du Sud",
        GH: "Ghana",
        GI: "Gibraltar",
        GR: "Grèce",
        GD: "Grenade",
        GL: "Groenland",
        GP: "Guadeloupe",
        GU: "Guam",
        GT: "Guatemala",
        GG: "Guernesey",
        GN: "Guinée",
        GQ: "Guinée équatoriale",
        GW: "Guinée-Bissau",
        GY: "Guyana",
        GF: "Guyane française",
        HT: "Haïti",
        HN: "Honduras",
        HU: "Hongrie",
        BV: "Île Bouvet",
        CX: "Île Christmas",
        IM: "Île de Man",
        NF: "Île Norfolk",
        AX: "Îles Åland",
        KY: "Îles Caïmans",
        CC: "Îles Cocos",
        CK: "Îles Cook",
        FO: "Îles Féroé",
        HM: "Îles Heard et McDonald",
        FK: "Îles Malouines",
        MP: "Îles Mariannes du Nord",
        MH: "Îles Marshall",
        UM: "Îles mineures éloignées des États-Unis",
        PN: "Îles Pitcairn",
        SB: "Îles Salomon",
        TC: "Îles Turques-et-Caïques",
        VG: "Îles Vierges britanniques",
        VI: "Îles Vierges des États-Unis",
        IN: "Inde",
        ID: "Indonésie",
        IQ: "Irak",
        IR: "Iran",
        IE: "Irlande",
        IS: "Islande",
        IL: "Israël",
        IT: "Italie",
        JM: "Jamaïque",
        JP: "Japon",
        JE: "Jersey",
        JO: "Jordanie",
        KZ: "Kazakhstan",
        KE: "Kenya",
        KG: "Kirghizistan",
        KI: "Kiribati",
        KW: "Koweït",
        RE: "La Réunion",
        LA: "Laos",
        LS: "Lesotho",
        LV: "Lettonie",
        LB: "Liban",
        LR: "Libéria",
        LY: "Libye",
        LI: "Liechtenstein",
        LT: "Lituanie",
        LU: "Luxembourg",
        MK: "Macédoine du Nord",
        MG: "Madagascar",
        MY: "Malaisie",
        MW: "Malawi",
        MV: "Maldives",
        ML: "Mali",
        MT: "Malte",
        MA: "Maroc",
        MQ: "Martinique",
        MU: "Maurice",
        MR: "Mauritanie",
        YT: "Mayotte",
        MX: "Mexique",
        MD: "Moldavie",
        MC: "Monaco",
        MN: "Mongolie",
        ME: "Monténégro",
        MS: "Montserrat",
        MZ: "Mozambique",
        MM: "Myanmar (Birmanie)",
        NA: "Namibie",
        NR: "Nauru",
        NP: "Népal",
        NI: "Nicaragua",
        NE: "Niger",
        NG: "Nigéria",
        NU: "Niue",
        NO: "Norvège",
        NC: "Nouvelle-Calédonie",
        NZ: "Nouvelle-Zélande",
        OM: "Oman",
        UG: "Ouganda",
        UZ: "Ouzbékistan",
        PK: "Pakistan",
        PW: "Palaos",
        PA: "Panama",
        PG: "Papouasie-Nouvelle-Guinée",
        PY: "Paraguay",
        NL: "Pays-Bas",
        BQ: "Pays-Bas caribéens",
        PE: "Pérou",
        PH: "Philippines",
        PL: "Pologne",
        PF: "Polynésie française",
        PR: "Porto Rico",
        PT: "Portugal",
        QA: "Qatar",
        HK: "R.A.S. chinoise de Hong Kong",
        MO: "R.A.S. chinoise de Macao",
        CF: "République centrafricaine",
        DO: "République dominicaine",
        RO: "Roumanie",
        GB: "Royaume-Uni",
        RU: "Russie",
        RW: "Rwanda",
        EH: "Sahara occidental",
        BL: "Saint-Barthélemy",
        KN: "Saint-Christophe-et-Niévès",
        SM: "Saint-Marin",
        MF: "Saint-Martin",
        SX: "Saint-Martin (partie néerlandaise)",
        PM: "Saint-Pierre-et-Miquelon",
        VC: "Saint-Vincent-et-les-Grenadines",
        SH: "Sainte-Hélène",
        LC: "Sainte-Lucie",
        SV: "Salvador",
        WS: "Samoa",
        AS: "Samoa américaines",
        ST: "Sao Tomé-et-Principe",
        SN: "Sénégal",
        RS: "Serbie",
        SC: "Seychelles",
        SL: "Sierra Leone",
        SG: "Singapour",
        SK: "Slovaquie",
        SI: "Slovénie",
        SO: "Somalie",
        SD: "Soudan",
        SS: "Soudan du Sud",
        LK: "Sri Lanka",
        SE: "Suède",
        CH: "Suisse",
        SR: "Suriname",
        SJ: "Svalbard et Jan Mayen",
        SY: "Syrie",
        TJ: "Tadjikistan",
        TW: "Taïwan",
        TZ: "Tanzanie",
        TD: "Tchad",
        CZ: "Tchéquie",
        TF: "Terres australes françaises",
        IO: "Territoire britannique de l’océan Indien",
        PS: "Territoires palestiniens",
        TH: "Thaïlande",
        TL: "Timor oriental",
        TG: "Togo",
        TK: "Tokelau",
        TO: "Tonga",
        TT: "Trinité-et-Tobago",
        TN: "Tunisie",
        TM: "Turkménistan",
        TR: "Turquie",
        TV: "Tuvalu",
        UA: "Ukraine",
        UY: "Uruguay",
        VU: "Vanuatu",
        VE: "Venezuela",
        VN: "Vietnam",
        WF: "Wallis-et-Futuna",
        YE: "Yémen",
        ZM: "Zambie",
        ZW: "Zimbabwe",
      }

      return mapping[code] || null
    }
  }
}



// WEBPACK FOOTER //
// ./client/mixins/enums.js